import styled from "styled-components"
import { TripleGrid } from "../../Global"

export const TrainingSlide = styled(TripleGrid)`
  position: relative;
  width: 100%;
  gap: 25px;
`
